import React, { Component } from 'react';
import ConsoleTile from 'components/shared/ConsoleTile/ConsoleTile';
import MapListView from 'components/features/DeviceView/MapListView/MapListView';
import DropModal from 'components/shared/DropModal/DropModal';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import './DeviceView.css';
import {
  updateMapListViewSwitch,
  updateSelectListNotification,
  setLocalNameFilter,
  setDropModalOpen,
  updateDevicesPageSelectedDeviceGroupName,
  clearSelectedDevicesList,
  updateDevicesPageBulkManageListsModal,
  updateDevicesPageManageColumnsModal,
  updateAlarmSort,
  addFilter,
  addFilterToAllTabs,
  doDeviceGroupUpdate,
  removeFilter,
  updateDevicesPageCreateSiteModal
} from 'redux/actions';
import { MapListViewSwitchStates } from 'redux/reducers';
import { connect } from 'react-redux';
import SearchBar from 'components/shared/SearchBar/SearchBar';
import DeviceExport from './DeviceExport/DeviceExport';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import { isObjectEmpty } from 'common/utils/helpers';
import { Status, LOADING_CIRCLE, DEVICES_PAGE_TAB } from 'common/utils/constants';

const mapDispatchToProps = {
  updateMapListViewSwitch,
  updateSelectListNotification,
  setLocalNameFilter,
  updateAlarmSort,
  setDropModalOpen,
  updateDevicesPageSelectedDeviceGroupName,
  clearSelectedDevicesList,
  updateDevicesPageBulkManageListsModal,
  updateDevicesPageManageColumnsModal,
  addFilter,
  addFilterToAllTabs,
  doDeviceGroupUpdate,
  removeFilter,
  updateDevicesPageCreateSiteModal
};

const SELECT_LIST_NOTIFICATION_TEXT =
  'Please select a list of devices from the menu.\nThe grid view can only display devices from a\nsaved list.';

class DeviceView extends Component {
  constructor() {
    super();
    this.isDeviceListLoaded = false;
  }

  state = {
    manageListModalOpen: false,
    manageColumnsModalOpen: false
  };

  componentDidUpdate(prevProps) {
    // remove notification when on other tabs
    if (this.props.view !== MapListViewSwitchStates.GRID) {
      this.props.updateSelectListNotification(false);
      return;
    }

    if (prevProps.view !== this.props.view && !this.props.selectedDeviceGroupName) {
      this.props.updateSelectListNotification(true);
    } else if (
      prevProps.selectedDeviceGroupName !== this.props.selectedDeviceGroupName &&
      !this.props.selectedDeviceGroupName
    ) {
      this.props.updateSelectListNotification(true);
    }
  }

  selectListOnClick = () => {
    if (this.props.showSelectListNotification) {
      this.props.updateSelectListNotification(false);
    }
  };

  sortOnClick = (item) => {
    this.props.updateAlarmSort(item);
  };

  getDeviceGroupTitle = () => {
    if (this.props.selectedDeviceGroupName) return this.props.selectedDeviceGroupName;
    return this.getAllDeviceGroupPlaceHolder();
  };

  getAllDeviceGroupPlaceHolder = () => {
    if (this.props.activeTab === DEVICES_PAGE_TAB.pivot) return 'All pivots';
    if (this.props.activeTab === DEVICES_PAGE_TAB.echo) return 'All echos';
    return 'All devices';
  };

  render() {
    const deviceGroupName = this.getDeviceGroupTitle();
    let overlay = null;

    if (this.props.getUserDeviceGroupsStatus === Status.PENDING) {
      overlay = (
        <div id="Global_LoadingCircle_Overlay" className="Global_LoadingCircle_Overlay">
          {LOADING_CIRCLE}
        </div>
      );
    }

    let selectDevicesListTitle = (
      <div
        id="DeviceView_TileHeader_SelectDevicesListButton"
        className="DeviceView_TileHeader_SelectDevicesListButton"
        data-tip={'Select a devices list'}
      >
        <SvgAF img={IconLoader.icon_threeV} hover={IconLoader.icon_threeV_hover} />
      </div>
    );

    let allDevicesItem = (
      <div
        key={Math.random() * 100}
        id="DeviceView_TileHeader_SelectDevicesList_Item_Div"
        className="DeviceView_TileHeader_SelectDevicesList_Item_Div"
        onClick={() => {
          this.props.setDropModalOpen('selectDevicesList', false);
          if (this.props.selectedDeviceGroupName) {
            let newFilterDictionary = JSON.parse(JSON.stringify(this.props.filterDictionary));
            newFilterDictionary['deviceId'] && delete newFilterDictionary['deviceId'];
            this.props.updateDevicesPageSelectedDeviceGroupName(null);
            this.props.clearSelectedDevicesList(this.props.activeTab);
            // this.props.setFilterDictionary(newFilterDictionary)
            this.props.setLocalNameFilter('');
            this.props.removeFilter(this.props.activeTab, 'deviceId');
          }
        }}
      >
        <div className="DeviceView_TileHeader_SelectDevicesList_Item_Icon"></div>
        <div
          className="DeviceView_TileHeader_SelectDevicesList_Item_Text"
          data-tip={this.getAllDeviceGroupPlaceHolder()}
        >
          {this.getAllDeviceGroupPlaceHolder()}
        </div>
      </div>
    );

    let separater = (
      <div
        key={Math.random() * 100}
        id="DeviceView_TileHeader_SelectDevicesList_Separater_Div"
        className="DeviceView_TileHeader_SelectDevicesList_Separater_Div"
      ></div>
    );

    let bottomSpace = (
      <div
        key={Math.random() * 100}
        id="DeviceView_TileHeader_SelectDevicesList_BottomSpace_Div"
        className="DeviceView_TileHeader_SelectDevicesList_BottomSpace_Div"
      ></div>
    );

    let manageListsItem = (
      <div
        key={Math.random() * 100}
        id="DeviceView_TileHeader_SelectDevicesList_ManageListItem_Div"
        className="DeviceView_TileHeader_SelectDevicesList_ManageListItem_Div"
        onClick={() => {
          this.props.setDropModalOpen('selectDevicesList', false);
          //open the manage lists modal
          this.props.updateDevicesPageBulkManageListsModal(true);
        }}
      >
        <div
          id="DeviceView_TileHeader_SelectDevicesList_Item_Icon"
          className="DeviceView_TileHeader_SelectDevicesList_Item_Icon"
        >
          <SvgAF img={IconLoader.icon_manage_set} hover={IconLoader.icon_manage_set} />
        </div>
        <div
          id="DeviceView_TileHeader_SelectDevicesList_Item_Text"
          className="DeviceView_TileHeader_SelectDevicesList_Item_Text"
          data-tip={'Manage lists'}
        >
          Manage lists
        </div>
      </div>
    );

    let deviceGroupsItems = !isObjectEmpty(this.props.deviceGroups)
      ? Object.keys(this.props.deviceGroups).map((groupName, idx) => {
          let { devices, name, deviceGroupId, userId } = this.props.deviceGroups[groupName];
          return (
            <div
              key={idx}
              data-tip={groupName}
              id="DeviceView_TileHeader_SelectDevicesList_Item_Div"
              className="DeviceView_TileHeader_SelectDevicesList_Item_Div"
              onClick={() => {
                let deviceGroupDevices = [];
                devices.forEach((deviceId) => {
                  let bundle = this.props.bundles?.[deviceId];
                  if (bundle) {
                    for (let member of bundle.members) {
                      deviceGroupDevices.push(member.id);
                    }
                  } else {
                    deviceGroupDevices.push(deviceId);
                  }
                });
                this.props.setDropModalOpen('selectDevicesList', false);
                if (groupName !== this.props.selectedDeviceGroupName) {
                  let newFilterDictionary = JSON.parse(JSON.stringify(this.props.filterDictionary));
                  newFilterDictionary['deviceId'] = deviceGroupDevices;
                  this.props.setLocalNameFilter('');
                  this.props.updateDevicesPageSelectedDeviceGroupName(groupName);
                  this.props.clearSelectedDevicesList(this.props.activeTab);
                  this.props.addFilterToAllTabs({ deviceId: deviceGroupDevices });
                }
              }}
            >
              <div
                id="DeviceView_TileHeader_SelectDevicesList_Item_Icon"
                className="DeviceView_TileHeader_SelectDevicesList_Item_Icon"
              ></div>
              <div
                id="DeviceView_TileHeader_SelectDevicesList_Item_Text"
                className="DeviceView_TileHeader_SelectDevicesList_Item_Text"
              >
                {groupName}
              </div>
            </div>
          );
        })
      : [];

    deviceGroupsItems = [allDevicesItem, ...deviceGroupsItems, separater, manageListsItem, bottomSpace];

    let deviceGroupsDropdownHeader = (
      <div
        key={Math.random() * 100}
        id="DeviceView_TileHeader_SelectDevicesList_HeaderItem_Div"
        className="DeviceView_TileHeader_SelectDevicesList_HeaderItem_Div"
      >
        <div
          id="DeviceView_TileHeader_SelectDevicesList_Item_Text"
          className="DeviceView_TileHeader_SelectDevicesList_Item_Text"
        >
          Choose from your saved lists
        </div>
      </div>
    );

    let deviceGroupsDropdown = (
      <PerfectScrollbar>
        {overlay}
        {deviceGroupsDropdownHeader}
        <div id="DeviceView_TileHeader_SelectDevicesList" className="DeviceView_TileHeader_SelectDevicesList">
          {deviceGroupsItems}
        </div>
      </PerfectScrollbar>
    );

    let tileHeader = (
      <div id="DeviceView_TileHeader_Container" className={'DeviceView_TileHeader_Container'}>
        <div id="DeviceView_TileHeader__LeftDiv" className={'DeviceView_TileHeader__LeftDiv'}>
          <DropModal title={selectDevicesListTitle} name={'selectDevicesList'} onClick={this.selectListOnClick}>
            {deviceGroupsDropdown}
          </DropModal>
          {this.props.showSelectListNotification && (
            <div
              id="DeviceView_TileHeader_NotificationCircle"
              className={'DeviceView_TileHeader_NotificationCircle'}
            ></div>
          )}
          {this.props.showSelectListNotification && (
            <div id="DeviceView_TileHeader_Notification" className={'DeviceView_TileHeader_Notification'}>
              <div
                id="DeviceView_TileHeader_NotificationPointer"
                className={'DeviceView_TileHeader_NotificationPointer'}
              ></div>
              <div
                id="DeviceView_TileHeader_NotificationText_Container"
                className={'DeviceView_TileHeader_NotificationText_Container'}
              >
                <div id="DeviceView_TileHeader_NotificationText" className="DeviceView_TileHeader_NotificationText">
                  {SELECT_LIST_NOTIFICATION_TEXT.split('\n').map((text, index) => (
                    <p
                      key={index}
                      id="DeviceView_TileHeader_NotificationText_Single"
                      className={'DeviceView_TileHeader_NotificationText_Single'}
                    >
                      {text}
                    </p>
                  ))}
                </div>
                <div
                  id="DeviceView_TileHeader_NotificationText_CloseX"
                  className={'DeviceView_TileHeader_NotificationText_CloseX'}
                  onClick={this.selectListOnClick}
                >
                  <SvgAF img={IconLoader.icons_cross_small} hover={IconLoader.icons_cross_small_hover} />
                </div>
              </div>
            </div>
          )}
          <div id="DeviceView_TileHeader_Title" className={'DeviceView_TileHeader_Title'} data-tip={deviceGroupName}>
            {deviceGroupName}
          </div>
          <div
            id="DeviceView_TileHeader_ManageColumnButton_Box"
            className={'DeviceView_TileHeader_ManageColumnButton_Box'}
            onClick={() => {
              this.props.updateDevicesPageManageColumnsModal(true);
            }}
          >
            <div
              id="DeviceView_TileHeader_ManageColumnButton_Text"
              className={'DeviceView_TileHeader_ManageColumnButton_Text'}
            >
              Manage columns
            </div>
          </div>
          <DeviceExport activeTab={this.props.activeTab} filterDictionary={this.props.filterDictionary} />
          {/* TODO: future feature until further requirement details are defined */}
          {/* <DeviceMapCounter /> */}

          {this.props.view === MapListViewSwitchStates.GRID && this.props.selectedDeviceGroupName && (
            <div id="DeviceView_TileHeader_AlarmSort" className="DeviceView_TileHeader_AlarmSort">
              <Dropdown
                title="Sort by"
                hideArrow={true}
                isAlarmSort={true}
                data={['Severity', 'Device ID/Name']}
                sortOnClick={this.sortOnClick}
              />
            </div>
          )}
        </div>
        <div id="DeviceView_TileHeader_RightDiv" className={'DeviceView_TileHeader_RightDiv'}>
          <div id="DeviceView_TileHeader_ButtonBar" className={'DeviceView_TileHeader_ButtonBar'}>
            <button
              id="DeviceView_TileHeader_Button"
              className="DeviceView_TileHeader_Button"
              onClick={() => this.props.updateMapListViewSwitch(this.props.activeTab, MapListViewSwitchStates.SPLIT)}
            >
              <div
                id="DeviceView_TileHeader_ButtonBar_SingleButton"
                className="DeviceView_TileHeader_ButtonBar_SingleButton"
              >
                {this.props.view === MapListViewSwitchStates.SPLIT ? (
                  <SvgAF
                    img={IconLoader.icon_main_split_on}
                    hover={IconLoader.icon_main_split_on}
                    tooltip="Split view"
                  />
                ) : (
                  <SvgAF
                    img={IconLoader.icon_main_split}
                    hover={IconLoader.icon_main_split_hover}
                    tooltip="Split view"
                  />
                )}
              </div>
            </button>

            <button
              id="DeviceView_TileHeader_Button"
              className="DeviceView_TileHeader_Button"
              onClick={() => this.props.updateMapListViewSwitch(this.props.activeTab, MapListViewSwitchStates.LIST)}
            >
              <div
                id="DeviceView_TileHeader_ButtonBar_SingleButton"
                className="DeviceView_TileHeader_ButtonBar_SingleButton"
              >
                {this.props.view === MapListViewSwitchStates.LIST ? (
                  <SvgAF
                    img={IconLoader.icon_main_table_on}
                    hover={IconLoader.icon_main_table_on}
                    tooltip="List view"
                  />
                ) : (
                  <SvgAF
                    img={IconLoader.icon_main_table}
                    hover={IconLoader.icon_main_table_hover}
                    tooltip="List view"
                  />
                )}
              </div>
            </button>

            <button
              id="DeviceView_TileHeader_Button"
              className="DeviceView_TileHeader_Button"
              onClick={() => this.props.updateMapListViewSwitch(this.props.activeTab, MapListViewSwitchStates.GRID)}
            >
              <div
                id="DeviceView_TileHeader_ButtonBar_SingleButton"
                className="DeviceView_TileHeader_ButtonBar_SingleButton"
              >
                {this.props.view === MapListViewSwitchStates.GRID ? (
                  <SvgAF img={IconLoader.icon_main_grid_on} hover={IconLoader.icon_main_grid_on} tooltip="Grid view" />
                ) : (
                  <SvgAF img={IconLoader.icon_main_grid} hover={IconLoader.icon_main_grid_hover} tooltip="Grid view" />
                )}
              </div>
            </button>
          </div>
          <div id="DeviceView_TileHeader_SearchBar_Div" className={'DeviceView_TileHeader_SearchBar_Div'}>
            <SearchBar
              id={'devicesView'}
              customIcon={IconLoader.icon_search_blue}
              startingValue={this.props.filterDictionary.text !== '' ? this.props.filterDictionary.text : null}
              defaultText={'Search by Device ID'}
              searchQuery={
                //(inputString) => this.props.setLocalNameFilter(inputString)
                (inputString) => {
                  if (inputString === '' || inputString == null) {
                    this.props.removeFilter(this.props.activeTab, 'text');
                  }
                  this.props.addFilter(this.props.activeTab, { text: inputString });
                  // propagateFilters(this.props.filterDictionary);
                }
              }
              handleEnter={(event, searchBar) => {
                searchBar.props.searchQuery(searchBar.state.value);
                event.target.blur();
              }}
            />
          </div>
        </div>
      </div>
    );

    return (
      <div id="DeviceView_Container" className={'DeviceView_Container'}>
        <ConsoleTile tileHeader={tileHeader}>
          <div id="DeviceView_MapListView_Div" className={'DeviceView_MapListView_Div'}>
            <MapListView onSelectDeviceGroup={this.props.onSelectDeviceGroup} />
          </div>
        </ConsoleTile>
      </div>
    );
  }
}

export default connect((store) => {
  let getUserDeviceGroupsStatusName = 'GET-User-DeviceGroups';
  let filterDictionary = {};
  let view;

  const activeTab = store.ui.devicesPage.activeTab;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    filterDictionary = store.data.pivotFilterDictionary;
    view = store.ui.devicesPage.pivotTab.mapListViewSwitchState;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    filterDictionary = store.data.echoFilterDictionary;
    view = store.ui.devicesPage.echoTab.mapListViewSwitchState;
  } else {
    filterDictionary = store.data.allDevicesFilterDictionary;
    view = store.ui.devicesPage.allDevicesTab.mapListViewSwitchState;
  }

  return {
    activeTab,
    view,
    showSelectListNotification: store.ui.devicesPage.showSelectListNotification,
    // defaultSearchtext: store.data.filterDictionary.text,
    deviceGroups: store.ui.devicesPage.deviceGroups,
    selectedDeviceGroupName: store.ui.devicesPage.selectedDeviceGroupName,
    bundles: store.data.bundlesStorage.storedBundlesDictionary,
    getUserDeviceGroupsStatus: store.statuses[getUserDeviceGroupsStatusName],
    filterDictionary
  };
}, mapDispatchToProps)(DeviceView);
